import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../App';
import axios from 'axios';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL;

const EMOJIS = ['👍', '❤️', '🔥', '🎉', '😍', '💯'];

export default function ReactionButton({ postId }) {
  const { user } = useContext(AuthContext);
  const [reactions, setReactions] = useState({});
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    fetchReactions();
  }, [postId]);

  const fetchReactions = async () => {
    try {
      const response = await axios.get(`${API}/api/posts/${postId}/reactions`);
      setReactions(response.data);
    } catch (error) {
      console.error('Error fetching reactions:', error);
    }
  };

  const handleReaction = async (emoji) => {
    if (!user) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/api/posts/${postId}/reactions?emoji=${emoji}`, {}, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true
      });
      fetchReactions();
      setShowPicker(false);
    } catch (error) {
      console.error('Error adding reaction:', error);
    }
  };

  return (
    <div className="relative inline-block">
      <div className="flex items-center gap-2">
        {Object.entries(reactions).map(([emoji, count]) => (
          <button
            key={emoji}
            onClick={() => handleReaction(emoji)}
            className="flex items-center gap-1 px-3 py-1 bg-slate-100 hover:bg-slate-200 border-2 border-black rounded-full font-bold text-sm transition-all"
          >
            <span>{emoji}</span>
            <span>{count}</span>
          </button>
        ))}
        <Button
          onClick={() => setShowPicker(!showPicker)}
          variant="outline"
          size="sm"
          className="border-2 border-black rounded-full"
        >
          +
        </Button>
      </div>

      {showPicker && (
        <div className="absolute top-full mt-2 left-0 bg-white border-4 border-black rounded-xl p-3 shadow-brutal z-50">
          <div className="flex gap-2">
            {EMOJIS.map(emoji => (
              <button
                key={emoji}
                onClick={() => handleReaction(emoji)}
                className="text-2xl hover:scale-125 transition-transform"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}